import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import { ReactElement } from 'react';

type ComingSoonTooltipProps = {
  title: string;
  children: ReactElement;
};

export const ComingSoonTooltip = ({
  title,
  children,
}: ComingSoonTooltipProps) => {
  return (
    <Tooltip arrow title={`${title} coming soon!`} sx={{ width: '100%' }}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
        }}
      >
        {children}
      </Box>
    </Tooltip>
  );
};
